import { render, staticRenderFns } from "./BountiesIcon.vue?vue&type=template&id=1885a984&scoped=true"
import script from "./BountiesIcon.vue?vue&type=script&lang=js"
export * from "./BountiesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885a984",
  null
  
)

export default component.exports